export { default as EmbryoDetailSheet } from "./EmbryoDetailSheet";
export { CNPlotSection, MonogenicSection, PRSRow } from "./EmbryoDetailSheet";
export type {
  EmbryoDetailData,
  EmbryoDetailSheetProps,
  ChromosomeCN,
  MosaicismDetail,
  MonogenicFinding,
  PolygenicRisk,
} from "./embryo-detail.types";
